import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './testimonial17.css'

const Testimonial17 = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="testimonial17-max-width thq-section-max-width">
        <div className="testimonial17-container10">
          <h2 className="thq-heading-2">
            {props.heading1 ?? (
              <Fragment>
                <span className="testimonial17-text30">Testimonials</span>
              </Fragment>
            )}
          </h2>
          <span className="testimonial17-text11 thq-body-small">
            {props.content1 ?? (
              <Fragment>
                <span className="testimonial17-text28">
                  See what our clients have to say about their experience with
                  our startup support services.
                </span>
              </Fragment>
            )}
          </span>
        </div>
        <div className="thq-grid-2">
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card1"
              >
                <div className="testimonial17-container12">
                  <img
                    alt={props.author1Alt}
                    src={props.author1Src}
                    className="testimonial17-image1"
                  />
                  <div className="testimonial17-container13">
                    <strong className="thq-body-large">
                      {props.author1Name ?? (
                        <Fragment>
                          <span className="testimonial17-text29">John Doe</span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author1Position ?? (
                        <Fragment>
                          <span className="testimonial17-text35">
                            CEO, Tech Startup X
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text14 thq-body-small">
                  {props.review1 ?? (
                    <Fragment>
                      <span className="testimonial17-text33">
                        Working with the team made setting up our business in
                        Abu Dhabi a breeze. They took care of all the paperwork
                        efficiently.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card2"
              >
                <div className="testimonial17-container14">
                  <img
                    alt={props.author2Alt}
                    src={props.author2Src}
                    className="testimonial17-image2"
                  />
                  <div className="testimonial17-container15">
                    <strong className="thq-body-large">
                      {props.author2Name ?? (
                        <Fragment>
                          <span className="testimonial17-text24">
                            Jane Smith
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author2Position ?? (
                        <Fragment>
                          <span className="testimonial17-text37">
                            Founder, E-commerce Company Y
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text17 thq-body-small">
                  {props.review2 ?? (
                    <Fragment>
                      <span className="testimonial17-text26">
                        I highly recommend their BPO support services. It
                        allowed us to focus on growing our business while they
                        handled the day-to-day tasks.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card3"
              >
                <div className="testimonial17-container16">
                  <img
                    alt={props.author3Alt}
                    src={props.author3Src}
                    className="testimonial17-image3"
                  />
                  <div className="testimonial17-container17">
                    <strong className="thq-body-large">
                      {props.author3Name ?? (
                        <Fragment>
                          <span className="testimonial17-text36">
                            David Lee
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author3Position ?? (
                        <Fragment>
                          <span className="testimonial17-text32">
                            COO, Software Solutions Z
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text20 thq-body-small">
                  {props.review3 ?? (
                    <Fragment>
                      <span className="testimonial17-text27">
                        The team provided valuable insights and guidance
                        throughout the setup process. Their expertise was
                        invaluable.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="thq-animated-card-bg-2">
            <div className="thq-animated-card-bg-1">
              <div
                data-animated="true"
                className="thq-card testimonial17-card4"
              >
                <div className="testimonial17-container18">
                  <img
                    alt={props.author4Alt}
                    src={props.author4Src}
                    className="testimonial17-image4"
                  />
                  <div className="testimonial17-container19">
                    <strong className="thq-body-large">
                      {props.author4Name ?? (
                        <Fragment>
                          <span className="testimonial17-text34">
                            Sarah Johnson
                          </span>
                        </Fragment>
                      )}
                    </strong>
                    <span className="thq-body-small">
                      {props.author4Position ?? (
                        <Fragment>
                          <span className="testimonial17-text25">
                            CTO, AI Startup W
                          </span>
                        </Fragment>
                      )}
                    </span>
                  </div>
                </div>
                <span className="testimonial17-text23 thq-body-small">
                  {props.review4 ?? (
                    <Fragment>
                      <span className="testimonial17-text31">
                        We couldn&apos;t have asked for better support in
                        establishing our presence in Abu Dhabi. They exceeded
                        our expectations.
                      </span>
                    </Fragment>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonial17.defaultProps = {
  author2Name: undefined,
  author4Position: undefined,
  review2: undefined,
  author4Alt: 'Image of Sarah Johnson, CTO of AI Startup W',
  author2Alt: 'Image of Jane Smith, Founder of E-commerce Company Y',
  review3: undefined,
  content1: undefined,
  author1Name: undefined,
  heading1: undefined,
  review4: undefined,
  author3Position: undefined,
  author3Src:
    'https://images.unsplash.com/photo-1726137123744-149c9740aa04?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NzU2OTk3OHw&ixlib=rb-4.1.0&q=80&w=1080',
  author1Src:
    'https://images.unsplash.com/photo-1541130292430-a832637ddc0d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NzU2OTk3N3w&ixlib=rb-4.1.0&q=80&w=1080',
  review1: undefined,
  author3Alt: 'Image of David Lee, COO of Software Solutions Z',
  author4Src:
    'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NzU2OTk3OHw&ixlib=rb-4.1.0&q=80&w=1080',
  author4Name: undefined,
  author1Position: undefined,
  author3Name: undefined,
  author1Alt: 'Image of John Doe, CEO of Tech Startup X',
  author2Position: undefined,
  author2Src:
    'https://images.unsplash.com/photo-1526413232644-8a40f03cc03b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTc1NzU2OTk3OHw&ixlib=rb-4.1.0&q=80&w=1080',
}

Testimonial17.propTypes = {
  author2Name: PropTypes.element,
  author4Position: PropTypes.element,
  review2: PropTypes.element,
  author4Alt: PropTypes.string,
  author2Alt: PropTypes.string,
  review3: PropTypes.element,
  content1: PropTypes.element,
  author1Name: PropTypes.element,
  heading1: PropTypes.element,
  review4: PropTypes.element,
  author3Position: PropTypes.element,
  author3Src: PropTypes.string,
  author1Src: PropTypes.string,
  review1: PropTypes.element,
  author3Alt: PropTypes.string,
  author4Src: PropTypes.string,
  author4Name: PropTypes.element,
  author1Position: PropTypes.element,
  author3Name: PropTypes.element,
  author1Alt: PropTypes.string,
  author2Position: PropTypes.element,
  author2Src: PropTypes.string,
}

export default Testimonial17
